import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from 'baseConfig';
const token = localStorage.getItem('token')


export const chapterServiceApi = createApi({
    reducerPath: 'chapterServiceApi',
    baseQuery: fetchBaseQuery({ baseUrl: `${BASE_URL}` }),
    tagTypes: ['Chapter'],
    endpoints: (builder) => ({

        getAllChapter: builder.query({
            query: () => `/v1/chapter`,
            providesTags: ['Chapter'],
        }),

        getBySubCategoryId: builder.query({
            query: (id) => `/v1/chapter/getBySubCatId/${id}`,
            providesTags: ['Chapter'],
        }),
        // getById: builder.query({
        //     query: () => `/v1/chapter/getBySubCatId`,
        //     providesTags: ['Chapter'],
        // }),

        createChapter: builder.mutation({
            query: (values) => ({
                url: `/v1/chapter/add`,
                method: 'POST',
                body: values,
                headers: {
                    'authorization': token,
                    'Content-Type': 'application/json',
                },
            }),
            invalidatesTags: ['Chapter'],
        }),

        updateChapter: builder.mutation({
            query: ({ id, ...values }) => ({

                url: `/v1/chapter/update/${id}`,
                method: 'PUT',
                headers: {
                    'authorization': token,
                    'Content-Type': 'application/json',
                },
                body: values,
            }),
            invalidatesTags: ['Chapter'],
        }),

        reorderChapters: builder.mutation({
            query: (values) => ({
                url: `/v1/chapter/reorder`,
                method: 'PUT',
                headers: {
                    'authorization': token,
                    'Content-Type': 'application/json',
                },
                body: values,
            }),
            invalidatesTags: ['Chapter'],
        }),

        deleteChapter: builder.mutation({
            query: (id) => ({
                url: `/v1/chapter/delete/${id}`,
                method: 'DELETE',
                headers: {
                    'authorization': token,
                    'Content-Type': 'application/json',
                },
            }),
            invalidatesTags: ['Chapter'],
        }),
    }),
});

export const { useCreateChapterMutation, useDeleteChapterMutation, useGetAllChapterQuery, useUpdateChapterMutation, useGetBySubCategoryIdQuery, useReorderChaptersMutation } = chapterServiceApi;